import React from "react";
import ExcelJS from "exceljs";

const ExcelQueryvalidation = ({ data }) => {
    const exportExcelFile = async () => {
        if (!Array.isArray(data) || data.length === 0) {
            console.error("Data is not an array or is empty:", data);
            return;
        }

        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Sheet1');

        worksheet.columns = [
            { header: 'S.No', key: 'serial_no', width: 8 },
            { header: 'File No', key: 'file_no', width: 15 },
            { header: 'Law Hands', key: 'lh_branch', width: 20 },
            { header: 'Bank Name', key: 'bank_name', width: 25 },
            { header: 'Product', key: 'product_name', width: 15 },
            { header: 'Bank Branch', key: 'branch_name', width: 20 },
            { header: 'Borrower Name', key: 'borrower_name', width: 30 },
            { header: 'Property Owner Name', key: 'property_owner', width: 25 },
            { header: 'App ID', key: 'app_id', width: 25 },
            { header: 'Login Date', key: 'login_dt', width: 22 },
            { header: 'File Arrived Date & Time', key: 'arrived_dt', width: 22 },
            { header: 'File Emergent Initiate Date & Time', key: 'emergent_init_dt', width: 22 },
            { header: 'Emergent Initiate Type', key: 'emergent_type', width: 18 },
            { header: 'Emergent Initiate By', key: 'emergent_by', width: 20 },
            { header: 'File Initial Status', key: 'initial_status', width: 18 },
            { header: 'File Completed Status', key: 'completed_status', width: 20 },
            { header: 'File Picked By', key: 'picked_by', width: 18 },
            { header: 'File Picked Date & Time', key: 'picked_dt', width: 22 },
            { header: 'File Completed Date & Time', key: 'completed_dt', width: 22 },
            { header: 'File Waiting Time', key: 'waiting_time', width: 15 },
            { header: 'File Working Time', key: 'working_time', width: 15 },
            { header: 'Pending Queries Details', key: 'pending_queries', width: 20 },
            { header: 'Received Documents', key: 'received_documents', width: 50 },
            { header: 'Raised Query Details', key: 'raised_query_details', width: 50 },
            { header: 'No of Times Query Raised', key: 'no_of_time_query_raised', width: 20 },
            { header: 'Total Count of Queries', key: 'total_query_count', width: 18 },
            { header: 'Total LODs', key: 'no_of_lod', width: 12 },
            { header: 'Total Related Lod', key: 'no_of_lod_related', width: 15 },
            { header: 'Total Not Related', key: 'no_of_lod_not_related', width: 15 },
            { header: 'Received LOD Count', key: 'lod_count', width: 18 },
            { header: 'Received Lod Count Related', key: 'active_lod', width: 22 },
            { header: 'Received Lod Count Not Related', key: 'inactive_lod', width: 25 }
        ];

        // Style header row
        const headerRow = worksheet.getRow(1);
        headerRow.eachCell((cell) => {
            cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFFF00' },
            };
            cell.font = { bold: true, size: 11 };
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' }
            };
        });

        data.forEach((item, index) => {
            // Use pre-calculated values if available, otherwise calculate
            const waitingTime = item.waiting_time || calculateTimeDifference(item.arrived_dt, item.picked_dt);
            const workingTime = item.working_time || calculateTimeDifference(item.picked_dt, item.completed_dt);

            // Process document list according to your sample structure
            let documentListStr = '';
            if (Array.isArray(item.document_list) && item.document_list.length > 0) {
                documentListStr = item.document_list
                    .map(doc => {
                        if (doc && typeof doc === 'object') {
                            const value = doc.mergedValue || doc.value || '';
                            return value.replace(/\n$/, '').trim();
                        }
                        return String(doc).trim();
                    })
                    .filter(Boolean)
                    .join('\n');
            } else if (typeof item.document_list === 'string') {
                documentListStr = item.document_list;
            }
           
            // Process document list according to your sample structure
            let pending_queriesStr = '';
            if (Array.isArray(item.pending_queries) && item.pending_queries.length > 0) {
                pending_queriesStr = item.pending_queries
                    .map(doc => {
                        if (doc && typeof doc === 'object') {
                            const value = doc.mergedValue || doc.value || '';
                            return value.replace(/\n$/, '').trim();
                        }
                        return String(doc).trim();
                    })
                    .filter(Boolean)
                    .join('\n');
            } else if (typeof item.pending_queries === 'string') {
                pending_queriesStr = item.document_list;
            }

            const rowData = {
                serial_no: index + 1,
                file_no: item.file_no || item.file_name || '',
                lh_branch: item.lh_branch || '',
                bank_name: item.bank_name || '',
                product_name: item.product_name || '',
                branch_name: item.branch_name || '',
                borrower_name: item.borrower_name || '',
                property_owner: item.property_owner || '',
                app_id: item.app_id || '',
                login_dt: item.login_dt || '',
                arrived_dt: item.arrived_dt || '',
                emergent_init_dt: item.emergent_init_dt || '',
                emergent_type: item.emergent_type || '',
                emergent_by: item.emergent_by || '',
                initial_status: item.initial_status || '',
                completed_status: item.completed_status || '',
                picked_by: item.picked_by || '',
                picked_dt: item.picked_dt || '',
                completed_dt: item.completed_dt || '',
                waiting_time: waitingTime,
                working_time: workingTime,
                pending_queries: item.pending_queries || '',
                received_documents: documentListStr,
                raised_query_details: item.received_queries || '',
                no_of_time_query_raised: item.no_of_time_query_raised ?? 0,
                total_query_count: item.total_query_count ?? 0,
                no_of_lod: item.no_of_lod ?? '0',
                no_of_lod_related: item.no_of_lod_related ?? '0',
                no_of_lod_not_related: item.no_of_lod_not_related ?? '0',
                lod_count: item.lod_count ?? '0',
                active_lod: item.active_lod ?? '0',
                inactive_lod: item.inactive_lod ?? '0'
            };

            const row = worksheet.addRow(rowData);

            row.eachCell((cell, colNumber) => {
                cell.alignment = {
                    vertical: 'middle',
                    horizontal: colNumber === 23 || colNumber === 24 ? 'left' : 'center',
                    wrapText: true
                };
                cell.border = {
                    top: { style: 'thin' },
                    left: { style: 'thin' },
                    bottom: { style: 'thin' },
                    right: { style: 'thin' }
                };
                cell.font = { size: 10 };

                // Format numeric columns
                const numericColumns = [25, 26, 27, 28, 29, 30, 31, 32];
                if (numericColumns.includes(colNumber) && cell.value !== null && cell.value !== '') {
                    cell.numFmt = '0';
                }
            });

            // Set row height based on document list
            const lineCount = documentListStr ? documentListStr.split('\n').length : 1;
            row.height = Math.max(25, Math.min(lineCount * 15, 150));
        });

        worksheet.autoFilter = {
            from: 'A1',
            to: worksheet.getCell(worksheet.rowCount, worksheet.columnCount).address
        };

        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });
        const url = window.URL.createObjectURL(blob);
        const anchor = document.createElement('a');

        const currentDate = new Date();
        const formattedDate = `${currentDate.getDate().toString().padStart(2, '0')}-${(currentDate.getMonth() + 1).toString().padStart(2, '0')}-${currentDate.getFullYear()}`;

        anchor.href = url;
        anchor.download = `Query_Validation_Report_${formattedDate}.xlsx`;
        anchor.click();
        window.URL.revokeObjectURL(url);
    };

    const calculateTimeDifference = (startDate, endDate) => {
        if (!startDate || !endDate) return '';
        try {
            const parseDate = (dateStr) => {
                const [datePart, timePart] = dateStr.split(' ');
                const [day, month, year] = datePart.split('-');
                return new Date(`${year}-${month}-${day}T${timePart || '00:00:00'}`);
            };
            const start = parseDate(startDate);
            const end = parseDate(endDate);
            const diffMs = end - start;
            if (diffMs < 0) return '';
            const hours = Math.floor(diffMs / (1000 * 60 * 60));
            const minutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((diffMs % (1000 * 60)) / 1000);
            return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
        } catch (error) {
            console.error('Error calculating time difference:', error);
            return '';
        }
    };

    return (
        <button
            className="excel-download-btn"
            onClick={exportExcelFile}
            style={{
                padding: '8px 16px',
                backgroundColor: '#4CAF50',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer',
                fontSize: '14px',
                margin: '10px 0'
            }}
        >
            Download Query Validation Report
        </button>
    );
};

export default ExcelQueryvalidation;